import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useToast } from '../hooks/use-toast';
import api from '../services/api';

const ForgotPassword = () => {
  const [loginId, setLoginId] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/auth/password-recovery', { email: loginId });
      setSent(true);
      toast({
        title: 'Solicitação recebida',
        description: response.data?.message || 'Confira as instruções enviadas para o e-mail cadastrado.',
      });
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao solicitar recuperação',
        description: error.response?.data?.detail || 'Tente novamente em alguns minutos.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <Card className="relative w-full max-w-md shadow-2xl">
        <CardHeader className="space-y-4 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-8 w-8 text-primary" strokeWidth={1.5} />
          </div>
          <CardTitle className="text-3xl font-bold tracking-tight">Recuperar senha</CardTitle>
          <CardDescription className="text-base">
            Informe CPF/CNPJ ou e-mail para receber as instruções de recuperação.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-6">
              <div className="rounded-lg border border-border/50 bg-muted/50 p-4 text-sm text-muted-foreground">
                Se os dados estiverem cadastrados, enviaremos um link seguro para o e-mail associado à conta.
              </div>
              <Button asChild className="w-full h-11 rounded-full">
                <Link to="/login">Voltar para login</Link>
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="recovery-login">CPF/CNPJ ou e-mail</Label>
                <Input
                  id="recovery-login"
                  type="text"
                  value={loginId}
                  onChange={(event) => setLoginId(event.target.value)}
                  required
                  className="h-11"
                  data-testid="password-recovery-login-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full h-11 rounded-full shadow-lg hover:shadow-xl"
                disabled={loading}
                data-testid="password-recovery-submit-button"
              >
                {loading ? 'Enviando...' : 'Enviar instruções'}
              </Button>
            </form>
          )}

          <div className="mt-6">
            <Button asChild variant="ghost" className="w-full">
              <Link to="/login">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Voltar para login
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPassword;
